import React from 'react';

export const TASK_LABEL_MAX = 80;

// "Naziv zadatka": optional, but REQUIRED (red border + message) when the category
// already exists on the project for this user.
export default function TaskLabelField({ value, onChange, required = false, error = '' }) {
  const missing = required && !value.trim();
  const message = error || (missing
    ? 'This category already exists on the project. Add a short task name (e.g. cutout prep).'
    : '');
  return (
    <div className="mt-1">
      <input
        type="text"
        value={value}
        maxLength={TASK_LABEL_MAX}
        onChange={(e) => onChange(e.target.value)}
        placeholder={required ? 'Task name (required)' : 'Task name'}
        aria-invalid={Boolean(message)}
        className={`w-full text-[13px] text-ink rounded-tc-sm px-3 py-2.5 min-h-[44px] ${message ? 'border-[1.5px] border-danger bg-danger-soft' : 'bg-surface border border-line-strong'}`}
      />
      {message && <p className="text-[11px] text-danger-ink mt-1">{message}</p>}
    </div>
  );
}
